import { render, staticRenderFns } from "./globalModal.vue?vue&type=template&id=63ba1bc4&scoped=true"
import script from "./globalModal.vue?vue&type=script&lang=js"
export * from "./globalModal.vue?vue&type=script&lang=js"
import style0 from "./globalModal.vue?vue&type=style&index=0&id=63ba1bc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba1bc4",
  null
  
)

export default component.exports